module.exports = __webpack_public_path__ + "img/ice-cream.0cfe8393.svg";